import { h, Component } from 'preact';
import { connect } from 'preact-redux';
import classNames from 'classnames';
import Logo from '../header/Logo';
import SearchBar from 'app/desktop/components/search/SearchBar';
import Notifications from 'app/desktop/components/notifications/Notifications';
import UserNav from 'app/desktop/components/userNav/UserNav';
import PrimaryNav from 'app/desktop/components/navbar/PrimaryNav';
import SubNav from 'app/desktop/components/navbar/SubNav';
import Categories from 'app/desktop/components/categories/Categories';
import SignInContainer from 'app/desktop/components/userNav/SignInContainer';
import UserNavCart from 'app/desktop/components/userNav/UserNavCart';
import CategoriesFlyout from '../categories/CategoriesFlyout';

export class Header extends Component {
  render() {
    const { flags } = this.props;
    return (
      <div id="ls-header-wrapper">
        <div className="ls-header-top">
          <div
            id="ls-header-top-row"
            className="ls-header-top-row page-container"
          >
            <Logo {...this.props} />
            <Categories />
            <div id="ls-search-wrapper" className="ls-search-wrapper">
              <SearchBar />
            </div>
            <UserNavCart />
            <Notifications />
            <SignInContainer />
            <div
              className={classNames('user-wrapper', {
                'lang-select': flags.showLanguageSelector,
              })}
            >
              <div id="ls-user-nav">
                <UserNav />
              </div>
            </div>
          </div>
        </div>
        <nav id="ls-channel-nav" className="ls-channel-nav">
          <CategoriesFlyout />
          <PrimaryNav />
          <SubNav />
        </nav>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  app: state.app,
  flags: state.flags,
});

export default connect(
  mapStateToProps,
  {}
)(Header);
